//import { uploadBase64 } from 'helpers/fb-storage';

export const create = async data => ({ ...data }); // , logo: (await uploadBase64(data?.logo))[0]

export const update = async data => {
 /* if (data?.logo) data.logo = (await uploadBase64(data.logo))[0];
 if (data?.banner) data.banner = (await uploadBase64(data.banner))[0];
 if (data?.documents) {
  data.documents = data.documents.filter(e => !/undefined|null/.test(e.doc));
  for (var i = 0; i < data.documents.length; i++) {
   data.documents[i].doc = (await uploadBase64(data.documents[i].doc))[0] || null;
  }
 } */
 return data;
};

export const register = data => {
 const formData = new FormData();
 const inputFiles = document.getElementsByClassName('logo')[0].files;

 Object.entries(data).map(e => formData.append([e[0]], typeof e[1] === 'object' ? JSON.stringify(e[1]) : e[1]));

 for (var i = 0; i < inputFiles.length; i++) {
  formData.append('logo', inputFiles[i]);
 }

 return formData;
};
